import {
    React, RouteComponentProps,
    Formsy, form,
    i18n,
    observable, inject, observer,
    mui, ui, theme, pr
} from "aaa";

import { User } from "models/User";

/** 
 * Validations
 */

const iban = require("iban");
function matchRegex(value: any, regexp: RegExp) {
    return value === null || value === undefined || value === "" || regexp.test(value);
}

function isPhoneNumber(value: string): boolean {
    return matchRegex(value, /^[- +()0-9/]+$/);
}

function isDateDDMMYYYY(value: string): boolean {
    return matchRegex(value, /^(0?[1-9]|[12][0-9]|3[01])[\/\-.](0?[1-9]|1[012])[\/\-.]\d{4}$/);
}

function isPositiveCurrency(value: string): boolean {
    // return matchRegex(value, /^(?:\d*[,])?\d+$/);
    return matchRegex(value, /^[0-9]\d*((\,\d{0,2})?)$/);
}

Formsy.addValidationRule("isPhoneNumber", (values: any, value: any) => isPhoneNumber(value));
Formsy.addValidationRule("isIBAN", (values: any, value: any) => iban.isValid(value));
Formsy.addValidationRule("isDateDDMMYYYY", (values: any, value: any) => isDateDDMMYYYY(value));
Formsy.addValidationRule("isPositiveCurrency", (values: any, value: any) => isPositiveCurrency(value));


/**
 * Helper functions
 */

export function stringsToMenuItems(strings: string[]) {
    return strings.map((entry, index) => {
        return <mui.MenuItem key={index} value={index} primaryText={ui.__(entry as i18n.IDS)} />;
    });
}

export function renderYesNoGroup(title: string, groupName: string, yes?: boolean, onChange?: (event: any, value: any) => void) {
    return (
        <div style={{ display: ui.isMobile ? "block" : "flex", marginTop: theme.MARGIN }}>
            <div style={{ flexGrow: 1, marginRight: theme.MARGIN }}>
                {title}
            </div>
            {ui.isMobile && <br />}
            <form.FormsyRadioGroup
                name={groupName}
                style={{ display: "flex" }}
                onChange={(event: any, value: any) => onChange ? onChange(event, value) : null}
                defaultSelected={yes === undefined ? "no" /*"NOT_SELECTED"*/ : (yes ? "yes" : "no")}
            >
                <form.FormsyRadio
                    style={{ width: "auto", marginRight: theme.MARGIN }}
                    value="yes"
                    label={ui.__("yes")}
                />
                <form.FormsyRadio
                    style={{ width: "auto" }}
                    value="no"
                    label={ui.__("no")}
                />
            </form.FormsyRadioGroup>
        </div >
    );
}

export function renderActionButton(label: string, disabled: boolean = false, onClick?: any, isLoading?: boolean) {
    return <pr.HCenterDiv style={{ marginTop: theme.MARGIN_BIG }}>
        <mui.RaisedButton
            label={isLoading ? "" : label}
            style={{ minWidth: theme.ACTION_BUTTON_WIDTH }}
            primary={true}
            type="submit"
            disabled={disabled}
            onClick={onClick}
        >
            {isLoading === true &&
                <mui.CircularProgress size={26} color={"white"} style={{ marginTop: 5 }} />
            }
        </mui.RaisedButton>
    </pr.HCenterDiv>;
}

export const UserTextField = (props: {
    user: User,
    fieldName: string,
    validations?: string,
    validationErrorID?: string,
    required?: boolean,
    assignImmediaely?: boolean,
}) => {
    return <form.FormsyText
        name={props.fieldName}
        required={props.required === false ? false : true}
        validations={props.validations ? props.validations : "minLength:1"}
        floatingLabelText={ui.__(props.fieldName as i18n.IDS)}
        fullWidth={true}
        validationError={ui.__((props.validationErrorID ? props.validationErrorID : "error.requiredField") as i18n.IDS)}
        value={props.user[props.fieldName]}
        onChange={props.assignImmediaely === true ? (event: any, value: string) => props.user[props.fieldName] = value : undefined}
    />;
};

export function invalidateRequiredFields(formRef: any, invalidateForm: any) {
    let errs = {};
    formRef.inputs.forEach((input: any) => {
        // showRequired() is true if a required field is empty
        if (input.showRequired()) {
            errs[input.props.name] = ui.__("error.requiredField");
        }
    });
    invalidateForm(errs);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/formHelpers.tsx